<template>
  <modal class="modal" name="new-playlist-modal" transition="pop-out" :width="modalWidth" height="auto" :adaptive="true" @before-open="beforeOpen">
    <div class="flex justify-end w-100">
      <a @click="closeModal" class="pa3 pointer primary textColor">
        <font-awesome-icon icon="times"/>
      </a>
    </div>
    <div class=" flex flex-column items-center mb3">
      <h1 v-show="!isEdit" class="tc mt0 f4 f3-ns textColor">{{ $t("playlists.newPlaylist.title") }}</h1>
      <h1 v-show="isEdit" class="tc mt0 f4 f3-ns textColor">{{ $t("playlists.edit.title") }}</h1>
      <div class="mv2">
        <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
      </div>
      <div class="flex flex-wrap justify-around w-100 ph3">
        <upload-image @uploadFinished="handleUploadFinished" @uploadStart="disabled = true" path="/playlists/upload/picture" :picturePath="picturePath" :newPlaylist="true"/>
        <div class="w-100 w-50-ns ph3 flex flex-column justify-end">
          <div class="mt3 mt0-ns">
            <span class="dark-red f7" v-if="$v.title.$error && !$v.title.required">{{ $t("error.playlistNameRequired")}}</span>
            <input class="w-100 ph1 pv2 input" :class="{error: $v.title.$error}" @blur="$v.title.$touch"
              v-model="title" name="title" :placeholder="$t('playlists.newPlaylist.playlistName')">
            <div class="flex-ns justify-center items-center mv3">
              <label class="ma2 textColor">
                <input v-model="type" name="type" type="radio" value="0">{{ $t('playlists.type.public') }}</label>
              <label class="ma2 textColor">
                <input v-model="type" name="type" type="radio" value="1" checked>{{ $t('playlists.type.private') }}</label>
            </div>
          </div>
          <div class="flex justify-center">
            <button v-show="track" class="btn" :class="{'pointer': !disabled}" @click.prevent="savePlaylist()" :disabled="disabled">{{$t("playlists.newPlaylist.saveAndAdd")}}</button>
            <button v-show="!track" class="btn" :class="{'pointer': !disabled}" @click.prevent="savePlaylist()" :disabled="disabled">{{$t("app.save")}}</button>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import UploadImage from '@/components/UploadImage.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
const MODAL_WIDTH = 500

export default {
  name: 'new-playlist',
  data () {
    return {
      track: null,
      title: '',
      type: 1,
      picture: '',
      picturePath: '',
      color: '#808080',
      size: '20px',
      isEdit: false,
      disabled: false
    }
  },
  components: {
    ClipLoader,
    FontAwesomeIcon,
    UploadImage
  },
  created () {
    this.modalWidth = window.innerWidth < MODAL_WIDTH
      ? MODAL_WIDTH / 2
      : MODAL_WIDTH
  },
  computed: {
    ...mapGetters('playlist', [
      'error',
      'newPlaylistId'
    ]),
    loading () {
      return this.$loading.isLoading('playlist setPlaylist') || this.$loading.isLoading('playlist setPlaylistAndTrack') || this.$loading.isLoading('playlist edit')
    }
  },
  methods: {
    ...mapActions('playlist', [
      'setPlaylist',
      'resetError',
      'edit',
      'setPlaylistAndTrack'
    ]),
    beforeOpen (event) {
      this.resetError()
      this.$v.$reset()
      this.track = event.params.track
      if (event.params.playlist) {
        this.title = event.params.playlist.title
        this.picture = event.params.playlist.picture
        this.picturePath = event.params.picturePath
        this.type = event.params.playlist.type
        this.id = event.params.playlist.id
        this.isEdit = true
      } else {
        this.title = ''
        this.picture = ''
        this.type = 1
        this.id = ''
        this.isEdit = false
      }
    },
    closeModal () {
      this.$modal.hide('new-playlist-modal')
    },
    newPlaylist () {
      if (this.track) {
        this.setPlaylistAndTrack({title: this.title, picture: this.picture, type: this.type, trackId: this.track.id}).then(() => {
          this.closeModal()
          this.$toasted.show(this.$t('playlists.newPlaylist.success'), {type: 'success'})
        }).catch((e) => {
          this.$toasted.show(this.error.message, {type: 'error'})
        })
      } else {
        this.setPlaylist({playlist: this.playlist}).then(() => {
          this.closeModal()
          this.$toasted.show(this.$t('playlists.newPlaylist.success'), {type: 'success'})
        }).catch((e) => {
          this.$toasted.show(this.error.message, {type: 'error'})
        })
      }
    },
    editPlaylist () {
      this.edit({title: this.title, picture: this.picture, type: this.type, playlistId: this.id}).then(() => {
        this.closeModal()
        this.$toasted.show(this.$t('playlists.edit.success'), {type: 'success'})
      }).catch((e) => {
        this.$toasted.show(this.error.message, {type: 'error'})
      })
    },
    savePlaylist () {
      if (!this.$v.$invalid) {
        if (this.isEdit) {
          this.editPlaylist()
        } else {
          this.newPlaylist()
        }
      } else {
        this.$v.$touch()
      }
    },
    handleUploadFinished (event) {
      this.picture = event
      this.disabled = false
    }
  },
  validations: {
    title: {
      required
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/variables.scss';
  button:disabled .primary{
    color: #7b7a7b;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/playlist/NewPlaylist.vue